<template>
    <div class="minhas-licitacoes-tabela">
        <az-container>
            <az-form>
                <div class="li-tabela">
                    <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                                  :pagination.sync="paginacaoInterna" :loading="false"
                                  no-data-text="Nenhuma licitação encontrada"
                                  hide-actions :class="cssTabela">
                        <template slot="items" slot-scope="props">
                            <td>{{ props.item.dataAbertura | az-date('DD/MM/YYYY HH:mm:ss')}}</td>
                            <td>{{ props.item.numeroEdital }}</td>
                            <td>{{ props.item.objeto }}</td>
                            <td>{{ props.item.orgao ? props.item.orgao.nome: '' }}</td>
                            <td>
                                <span v-if="favoritos">{{props.item.status | statusLicitacao}}</span>
                                <span v-else :class="getStyleStatusProposta(props.item.enviada)">
                                {{getStatusEnvioProposta(props.item.enviada)}}
                            </span>
                            </td>
                            <td>{{getModalidadeLicitacao(props.item.modalidade)}}</td>
                            <td class="table-actions" style="text-align: right">
                                <minhas-licitacoes-tabela-acao-principal :favoritos="favoritos"
                                                                         :licitacao="props.item"
                                                                         @click="$emit('acaoPrincipal', props.item)"
                                />
                                <v-tooltip top v-az-auth="'Licitacao.Visualizar'"
                                           v-if="mostrarBotaoVisualizar(props.item)" class="no-mobile">
                                  <a slot="activator" @click="$emit('visualizar',props.item)">
                                    <v-icon>search</v-icon>
                                  </a>
                                  Ver detalhes
                                </v-tooltip>
                                <v-tooltip top v-az-auth="'Licitacao.Visualizar'" class="mobile">
                                  <a slot="activator" @click="$emit('visualizar',props.item)">
                                    <v-icon>search</v-icon>
                                  </a>
                                  Ver detalhes
                                </v-tooltip>
                            </td>
                        </template>
                    </v-data-table>
                    <div class="az-pagination">
                        <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
                        <div class="az-select-pagination">
                            <span>Linhas por página:</span>
                            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                        </div>
                    </div>
                </div>
            </az-form>
        </az-container>
    </div>
</template>

<script>
    import MinhasLicitacoesTabelaAcaoPrincipal from './MinhasLicitacoesTabelaAcaoPrincipal'
    import {modalidadesLicitacao} from "@/commons/constants";

    export default {
        name: 'MinhasLicitacoesTabela',
        components: {MinhasLicitacoesTabelaAcaoPrincipal},
        props: ['itens', 'paginacao', 'paginas', 'totalItens', 'favoritos'],
        data() {
            return {
                modalidadesLicitacao,
                linhasPorPagina: [5, 10, 25, 50, 100],
                paginacaoInterna: this.paginacao
            }
        },
        computed: {
            colunas(){
                return this.criarColunas(7,
                    ['Data/Hora Abertura','Num. Edital','Objeto','Responsável',
                        this.favoritos ? 'Status' : 'Proposta', 'Modalidade', 'Ações'],
                    ['dataAbertura','numeroEdital', 'objeto', 'orgao.nome', 'status', 'modalidade', null],
                    [false,false,false,false,false,false,false],
                    ['left','left','left','left','left','left','center'],
                    ['150px','150px',null,'150px','150px','100px','150px'],
                    'primary--text')
            },
            cssTabela() {
                return {
                    'az-table-list': true,
                    'listagem-favoritos': this.favoritos,
                    'listagem-minhas-propostas': !this.favoritos
                }
            }
        },
        watch: {
            paginacaoInterna: {
                handler(novoValor) {
                    this.$emit('paginar', novoValor)
                },
                deep: true
            }
        },
        methods: {
            getStatusEnvioProposta(isEnviada) {
                if (isEnviada) {
                    return 'Enviada'
                }
                return 'Envio Pendente'
            },
            getStyleStatusProposta(isEnviada) {
                return {
                    'proposta-nao-enviada': !isEnviada
                }
            },
            mostrarBotaoVisualizar(licitacao) {
                return this.favoritos || this.podeAcessarPregao(licitacao)
            },
            getModalidadeLicitacao(modalidade) {
              return this.modalidadesLicitacao[modalidade]
            },
        }
    }
</script>

<style lang="stylus">
    .minhas-licitacoes-tabela
        .table-actions
            display flex
            align-items center

        .v-btn__content
            text-transform none

        .proposta-nao-enviada
            color red

    @media (max-width: 720px)
        .az-table-list .table-actions
            display: block !important
            text-align: center !important
            width: 100%

        .listagem-minhas-propostas
            td:nth-of-type(1):before
                content: "Data/Hora Abertura:"

            td:nth-of-type(2):before
                content: "Num. Edital:"

            td:nth-of-type(3):before
                content: "Objeto:"

            td:nth-of-type(4):before
                content: "Responsável:"

            td:nth-of-type(5):before
                content: "Proposta:"

            td:nth-of-type(6):before
                display none

        .listagem-favoritos
            td:nth-of-type(1):before
                content: "Data/Hora Abertura:"

            td:nth-of-type(2):before
                content: "Num. Edital:"

            td:nth-of-type(3):before
                content: "Objeto:"

            td:nth-of-type(4):before
                content: "Responsável:"

            td:nth-of-type(5):before
                content: "Status:"

            td:nth-of-type(6):before
                display none
</style>
